import { useQuery } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { Conversation, Meta, ToadMessage } from 'utils/types';

import { CONVERSATIONS } from '../utils/constants';

interface Result {
  data: Conversation & { messages: ToadMessage[] };
  meta: Meta;
}

export default function useGetConversation(
  conversationId?: string,
  options?: any,
) {
  const { accountId, accountUserId } = useAdminParams();
  const { state } = useProvider();
  const args = state;

  return useQuery<Result, Error>({
    queryKey: [CONVERSATIONS, conversationId],
    queryFn: async () => {
      const api = new Api(args);

      const data = await api.get(
        await withAcl({
          account: {
            url: `api/v1/channels/toad/conversations/${conversationId ?? ''}`,
          },
          admin: {
            // eslint-disable-next-line max-len
            url: `api/v2/accounts/${accountId}/users/${accountUserId}/channels/toad/conversations/${conversationId ?? ''}`,
          },
        }),
      );

      return data;
    },
    enabled: !!conversationId,
    ...options,
  });
}
